import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';

/** Relative `/api/...` is proxied to Flask in dev (see package.json `proxy`). */
const authUrl = (path) => {
    const base = (process.env.REACT_APP_API_BASE_URL || '').replace(/\/$/, '');
    return base ? `${base}${path}` : `/api${path}`;
};

const Login = ({ mode = 'login' }) => {
    const isRegister = mode === 'register';
    const [formData, setFormData] = useState({
        email: '',
        password: ''
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        setSuccess('');

        try {
            if (isRegister) {
                await axios.post(
                    authUrl('/auth/register'),
                    { ...formData, role: 'client' },
                    { withCredentials: true }
                );
                setSuccess('Account created. You can log in now.');
                navigate('/login');
                return;
            }

            const response = await axios.post(authUrl('/auth/login'), formData, {
                withCredentials: true
            });

            const { user } = response.data;

            if (user.role === 'admin') {
                navigate('/admin');
            } else {
                navigate('/client');
            }
        } catch (error) {
            console.error(isRegister ? 'Register error:' : 'Login error:', error);
            const msg =
                error.response?.data?.error ||
                (error.code === 'ERR_NETWORK' || error.message === 'Network Error'
                    ? 'Cannot reach API (start Flask on port 8000 and restart npm start).'
                    : null) ||
                error.message ||
                (isRegister ? 'Registration failed. Please try again.' : 'Login failed. Please try again.');
            setError(msg);
        } finally {
            setLoading(false);
        }
    };

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    return (
        <div className="login-container">
            <div className="login-card">
                <h2>{isRegister ? 'Register for Ad Auction Platform' : 'Login to Ad Auction Platform'}</h2>

                {error && (
                    <div className="alert alert-danger">
                        {error}
                    </div>
                )}

                {success && (
                    <div className="alert alert-success">
                        {success}
                    </div>
                )}

                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label htmlFor="email">Email:</label>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            required
                            className="form-control"
                            placeholder="Enter your email"
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="password">Password:</label>
                        <input
                            type="password"
                            id="password"
                            name="password"
                            value={formData.password}
                            onChange={handleChange}
                            required
                            className="form-control"
                            placeholder="Enter your password"
                        />
                    </div>

                    <button
                        type="submit"
                        className="btn btn-primary btn-block"
                        disabled={loading}
                    >
                        {loading
                            ? (isRegister ? 'Creating account...' : 'Logging in...')
                            : (isRegister ? 'Create account' : 'Login')}
                    </button>
                </form>

                <div className="login-info">
                    <p><strong>Need Help?</strong> Contact support for login assistance</p>
                    {isRegister ? (
                        <p><strong>Already have an account?</strong> <Link to="/login">Log in</Link></p>
                    ) : (
                        <p><strong>New User?</strong> <Link to="/register">Register as a client</Link></p>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Login;
